import {
  faBookOpen,
  faLocationDot,
  faBookSkull,
  faCommentDots,
} from '@fortawesome/pro-light-svg-icons';

export const PageDetails = {
  adminPanel: {
    id: 'adminPanel',
    title: 'Admin Panel',
    url: 'admin',
    breadcrumbs: [{ title: 'Dashboard', href: '/' }],
  },
  tutoring: {
    id: 'tutoring',
    page: 'tutoring',
    title: 'Tutoring',
    icon: faBookOpen,
    description:
      'Tutoring locations, and hours. Note: needs updating at the beginning of each semester.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Admin Panel', href: '/admin' },
    ],
  },
  locations: {
    id: 'locations',
    page: 'locations',
    title: 'Locations',
    icon: faLocationDot,
    description: 'Note: now only used for tutoring locations, to be used in Places & Hours widget.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Admin Panel', href: '/admin' },
    ],
  },
  feedback: {
    id: 'feedback',
    page: 'feedback',
    title: 'Feedback',
    icon: faCommentDots,
    description: 'Feedback from the users.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Admin Panel', href: '/admin' },
    ],
  },
  cognitoErrorLog: {
    id: 'cognitoErrorLog',
    page: 'cognito-error-log',
    title: 'Cognito Error Log',
    icon: faBookSkull,
    description: 'Error logs from Cognito.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Admin Panel', href: '/admin' },
    ],
  },
  frontendErrorLog: {
    id: 'frontendErrorLog',
    page: 'frontend-error-log',
    title: 'FE Error Log',
    icon: faBookSkull,
    description: 'Error logs from the Frontend.',
    breadcrumbs: [
      { title: 'Dashboard', href: '/' },
      { title: 'Admin Panel', href: '/admin' },
    ],
  },
};
